import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Card } from "@mui/material";
import FileUploader from "../../FileUploader";
import { endpoints } from "../../../services/apiurl";
import Input from "../../UI/Input/Input";
import PageTitle from "../../UI/PageTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import TextAreaInput from "../../UI/Input/TextAreaInput";

const AddEvents = () => {
  let history = useHistory();
  const [cat, setCat] = useState({
    name: "",
    address: "",
    couple_price: "",
    description: "",
    status: "",
    restro_id: "",
    female_stag_price: "",
    male_stag_price: "",
    other_stag_price: "",
    event_date: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileSelectSuccess = (file) => {
    setSelectedFile(file);
  };

  const handleFileSelectError = ({ error }) => {
    alert(error);
  };
  const [loading, setloading] = useState(false);
  const [rest, setRest] = useState([]);

  const {
    name,
    address,
    status,
    couple_price,
    restro_id,
    female_stag_price,
    male_stag_price,
    other_stag_price,
    event_date,
    description,
  } = cat;
  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    getRestaurentsDropDown();
  }, []);

  const getRestaurentsDropDown = async () => {
    await axios.post(endpoints.getRestaurentsDropDown).then((response) => {
      setRest(response.data.data);
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      alert("Please select image");
      return false;
    }
    setloading(true);
    const formData = new FormData();
    formData.append("description", description);
    formData.append("name", name);
    formData.append("address", address);
    formData.append("couple_price", couple_price);
    formData.append("restro_id", restro_id);
    formData.append("female_stag_price", female_stag_price);
    formData.append("male_stag_price", male_stag_price);
    formData.append("other_stag_price", other_stag_price);

    formData.append("event_date", event_date);

    formData.append("image", selectedFile);
    formData.append("status", status);
    await axios.post(endpoints.addEvent, formData).then((response) => {
      setloading(false);
      history.goBack();
    });
  };
  return (
    <div className="ui main">
      <PageTitle title="Add Event" linkurl="" linkTitle="" />

      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <div className="col col-6">
              <label>Restaurents </label>
              <select
                name="restro_id"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Restaurents</option>
                {rest.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>

            <Input
              id="name"
              label="Name"
              type="text"
              name="name"
              place="Name"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={name}
              class="col col-6"
            />
            {/* <Input id="couple_price" label="Couple Price" type="text" name="couple_price" place="Couple Price" onChange={(e) => onInputChange(e)}
                            requiredInput="" value={couple_price} class="col col-6"
                        /> */}
          </div>

          <div className="row">
            <Input
              id="couple_price"
              label="Couple Price"
              type="text"
              name="couple_price"
              place="Couple Price"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={couple_price}
              class="col col-6"
            />

            <Input
              id="female_stag_price"
              label="Female Stag Price"
              type="text"
              name="female_stag_price"
              place="Female Stag Price"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={female_stag_price}
              class="col col-6"
            />
          </div>

          <div className="row">
            <Input
              id="male_stag_price"
              label="Male Stag Price"
              type="text"
              name="male_stag_price"
              place="Male Stag Price"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={male_stag_price}
              class="col col-6"
            />

            <Input
              id="other_stag_price"
              label="Other Stag Price"
              type="text"
              name="other_stag_price"
              place="Other Stag Price"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={other_stag_price}
              class="col col-6"
            />
          </div>

          <div className="row">
            <Input
              id="eventDate"
              label="Event Date & Time"
              type="text"
              name="event_date"
              place="Event Date & Time"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={event_date}
              class="col col-6"
            />

            <div className="col col-6">
              <label>Status</label>
              <select
                name="status"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Status</option>
                <option value="2">InActive</option>
                <option value="1">Active</option>
              </select>
            </div>
          </div>

          <div className="row">
            <TextAreaInput
              id="address"
              label="Address"
              name="address"
              place="Address"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={address}
              class="col col-6"
            />

            <TextAreaInput
              id="description"
              label="Description"
              name="description"
              place="Description"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={description}
              class="col col-6"
            />
          </div>

          <div className="row">
            <div className="col col-6">
              <label>Image</label>
              <FileUploader
                onFileSelectSuccess={handleFileSelectSuccess}
                onFileSelectError={handleFileSelectError}
              />

              {selectedFile && (
                <div>
                  <p>Preview:</p>
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="Selected Logo"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddEvents;
